import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Papa } from 'ngx-papaparse';
import { CSVTicket } from 'src/app/models/ticket/ticket.model';
import { OrderCsvDataRow } from 'src/app/orders-table/models';

@Component({
  selector: 'app-csv-download',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (iconOnly) {
      <button class="csv-download" (click)="downloadCSV()">
        <div class="custom-icon csv">csv icon</div>
      </button>
    } @else {
      <button class="btn-secondary" (click)="downloadCSV()">
        <mat-icon svgIcon="csv_file" class="!h-[20px] !w-[20px]"></mat-icon>
        Download
      </button>
    } `,
  standalone: false,
})
export class CSVDownloadComponent {
  @Input() csvData: CSVTicket[] | OrderCsvDataRow[];

  @Input() fileName: string;

  @Input() iconOnly: boolean = true;

  private papa = inject(Papa);

  downloadCSV(): void {
    const csvFile: string = this.fileName;
    const csvUnparse = this.papa.unparse(this.csvData as any);
    const csvBlob = new Blob([csvUnparse], { type: 'text/csv;charset=utf-8;' });
    const csvURL = window.URL.createObjectURL(csvBlob);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', csvFile);
    tempLink.click();
  }
}
